export default class Region {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    customerID: 'validString',
    id: 'validString',
    name: 'validString',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createRegion(regionObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/region/new';
    req.body = regionObj;
    return await req.exec();
  }
  async updateRegion(regionObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/region/' + regionObj.id;
    req.body = regionObj;
    return await req.exec();
  }
  async deleteRegion(regionID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/region/' + regionID;
    return await req.exec();
  }
  async getRegion(regionID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/region/' + regionID;
    return await req.exec();
  }
  async getAllRegions() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/regions/';
    return await req.exec();
  }
}
